import { FormatType } from "../../Alert/Filter/FilterType";
import { ConfigurationPageTable } from "../interfaces";
import {
  ConfigurationFormType,
  ConfigurationPageType,
  ConfigurationTableFilterType,
  tableTabAt,
} from "../interfaces";
import { SURQUAL_BOOKING_STATUS_PAGE } from "./SURQUAL_BOOKING_STATUS";

export const MAPPING_BOOKING_STATUS_PAGE: ConfigurationPageTable = {
  type: ConfigurationPageType.TABLE,
  path: "statut-reservation",
  label: "RESERVATION_STATUS",
  menuLabel: "RESERVATION_STATUS",
  pageLabel: "RESERVATION_STATUS_TITLE_MAPPING",
  name: "mapping_booking_status",
  description: "CONF_DESC_MAPPING_RESA_STATUS",
  model: {
    entityName: "datafeed",
    label: "RESERVATION_STATUS",
    path: "/api/mapping/booking-statuses",
    bulkPath: "/api/mapping/booking-statuses/bulk-updates",
    name: "Statut Réservation",
    attributes: [
      {
        key: "datafeed",
        order: 1,
        label: "DATA_FEED_CODE",
        visible: true,
      },
      {
        key: "connector",
        order: 2,
        label: "CONNECTOR_CODE",
        visible: true,
      },
      {
        key: "nb_uh_r12",
        className: "progressOcc",
        order: 3,
        label: "OCC_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS,
        visible: true,
      },
      {
        key: "turnover_r12",
        className: "progressCA",
        order: 4,
        label: "CA_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "pm_r12",
        className: "progressPM",
        order: 5,
        label: "PM_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "booking_status.short_name",
        order: 6,
        label: "RESERVATION_STATUS",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/mapping/booking-statuses/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/mapping/booking-statuses/export" },
    import: { path: "/api/mapping/booking-statuses/presign-url" },
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Input,
        key: "datafeed",
        label: "DATA_FEED_CODE",
      },
      {
        type: ConfigurationFormType.Input,
        key: "connector",
        label: "CONNECTOR_CODE",
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/booking-statuses/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "booking_status",
        label: "RESERVATION_STATUS",
        labelKey: "short_name",
        subCreationForm: tableTabAt(SURQUAL_BOOKING_STATUS_PAGE.tabs, 0),
      },
    ],
    copyable: false,
    creatable: false,
    deletable: false,
    editable: true,
    editOptions: [
      {
        key: "datafeed",
        flex: "100%",
        readonly: true,
      },
      {
        key: "connector",
        flex: "100%",
        readonly: true,
      },
      {
        key: "booking_status",
        flex: "100%",
      },
    ],
    editSelectedOptions: [
      {
        key: "booking_status",
        flex: "100%",
      },
    ],
  },
};
